import { toDate } from 'date-fns-tz';
import store from '@/store';

export const getWithTimezone = (date: Date | string): Date => {
  return toDate(date, {
    timeZone: store.getters['campaign/state'].config?.timezone ?? 'Europe/Copenhagen'
  });
};
